import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import useAuth from '../hooks/useAuth'; // Import the custom authentication hook

const ProtectedRoute = ({ allowedRoles }) => {
  // Use the custom hook to get authentication state
  const { user, isAuthenticated, loading } = useAuth();

  // If the authentication check is still in progress, you can show a loading spinner
  if (loading) {
    return <div className="p-6 text-center">Loading authentication...</div>;
  }

  // Check if the user is authenticated and has a valid role
  if (isAuthenticated && allowedRoles.includes(user?.roleName)) {
    // If authenticated and authorized, render the child routes
    return <Outlet />;
  } else if (isAuthenticated) {
    // If authenticated but not authorized, redirect to an unauthorized page
    return <Navigate to="/" replace />;
  } else {
    // If not authenticated, redirect to the login page
    return <Navigate to="/login" replace />;
  }
};

export default ProtectedRoute;
